import React from 'react';
import PropTypes from 'prop-types';
import { useLabels, useRequestData } from 'wsm-common-data';
import { formatCurrency } from 'ddc-intl';
import { setClassNames } from '@ddc/classnames-js';
import { getTradeLabel, getVehicleDataString } from '../util/index';

const TradeMarkup = ({
	vehicleData: {
		year,
		model,
		trim,
		estimatedEquity,
		equityConsumptionEnabled: includeTrade
	}
}) => {
	const { locale, deviceType } = useRequestData();
	const isDesktop = deviceType === 'DESKTOP';
	const labels = useLabels();
	const isPositiveEquity = estimatedEquity >= 0;
	const isNegativeEquity = estimatedEquity < 0;
	const tradeClasses = [
		'text-left',
		'text-black',
		!isDesktop ? 'ddc-font-size-large my-3 mx-0 mb-5' : null
	];
	const tradeLabel = getTradeLabel({ includeTrade, estimatedEquity });
	const markup = labels.get(tradeLabel);
	const labelFails = tradeLabel === markup;

	if (labelFails) {
		return <p className={setClassNames(tradeClasses)}>{tradeLabel}</p>;
	} else if (includeTrade && isPositiveEquity) {
		const [firstLine, temp] = markup.split(
			'<span className="font-weight-bold">'
		);
		const [includes, temp2] = temp.split('</span>');
		const [secondLine] = temp2.split('{vehicleYearModelTrim}');
		return (
			<p className={setClassNames(tradeClasses)}>
				{firstLine}
				<span className="font-weight-bold">
					{includes.replace(
						'{estimatedEquity}',
						formatCurrency(estimatedEquity, locale)
					)}
				</span>
				{secondLine}
				<span className="font-weight-bold">
					{getVehicleDataString(year, model, trim)}
				</span>
				.
			</p>
		);
	} else if (includeTrade && isNegativeEquity) {
		const [firstLine, temp] = markup.split(
			'<span className="font-weight-bold">'
		);
		const [includes, temp2] = temp.split('</span>');
		const [secondLine] = temp2.split('{vehicleYearModelTrim}');
		return (
			<p className={setClassNames(tradeClasses)}>
				{firstLine}
				<span className="font-weight-bold">{includes}</span>
				{secondLine}
				<span className="font-weight-bold">
					{getVehicleDataString(year, model, trim)}
				</span>
				.
			</p>
		);
	} else if (!includeTrade && isPositiveEquity) {
		const [firstLine, temp] = markup.split(
			'<span className="font-weight-bold">'
		);
		const [doesNotInclude, temp2] = temp.split('</span>');
		const [secondLine, thirdLine] = temp2.split('{vehicleYearModelTrim}');
		return (
			<p className={setClassNames(tradeClasses)}>
				{firstLine}
				<span className="font-weight-bold">
					{doesNotInclude.replace(
						'{estimatedEquity}',
						formatCurrency(estimatedEquity, locale)
					)}
				</span>
				{secondLine}
				<span className="font-weight-bold">
					{getVehicleDataString(year, model, trim)}
				</span>
				{thirdLine}
			</p>
		);
	} else if (!includeTrade && isNegativeEquity) {
		const [firstLine, temp] = markup.split(
			'<span className="font-weight-bold">'
		);
		const [doesNotInclude, temp2] = temp.split('</span>');
		const [secondLine] = temp2.split('{vehicleYearModelTrim}');
		return (
			<p className={setClassNames(tradeClasses)}>
				{firstLine}
				<span className="font-weight-bold">{doesNotInclude}</span>
				{secondLine}
				<span className="font-weight-bold">
					{getVehicleDataString(year, model, trim)}
				</span>
				.
			</p>
		);
	}
	const [firstLine, temp] = markup.split(
		'<span className="font-weight-bold">'
	);
	const [doesNotInclude, secondLine] = temp.split('</span>');

	return (
		<p className={setClassNames(tradeClasses)}>
			{firstLine}
			<span className="font-weight-bold">{doesNotInclude}</span>
			{secondLine}
		</p>
	);
};

TradeMarkup.propTypes = {
	vehicleData: PropTypes.shape({
		year: PropTypes.number,
		make: PropTypes.string,
		model: PropTypes.string,
		trim: PropTypes.string,
		equityConsumptionEnabled: PropTypes.bool,
		estimatedEquity: PropTypes.number
	})
};

export default TradeMarkup;
